import { NotificationsResponse } from '../store/config/types';
import { post } from './base.service';
import { endpoints } from './endpoints';

export const notificationsService = {
  resendNotification,
  sendNotification,
};

async function sendNotification(paymentId: number): Promise<NotificationsResponse | undefined> {
  return await post<NotificationsResponse>(`${endpoints['notifications']}/payment/${paymentId}`, {})
    .then((response) => {
      return response.parsedBody;
    })
    .catch((error) => {
      throw error;
    });
}

async function resendNotification(notificationId: string): Promise<boolean | undefined> {
  return await post<boolean>(`${endpoints['notifications']}/resend/${notificationId}`, {})
    .then((response) => {
      return response.parsedBody;
    })
    .catch((error) => {
      throw error;
    });
}
